<template>
  <div>...</div>
</template>

<script>
export default {
  name: 'Login',

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$sso.login('fawful.se', 'http://localhost:8080/sso/callback')
    })
  }
}
</script>
